export default __webpack_public_path__ + "static/media/people_type_male_active.39786787.svg";